import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UserDataService } from '../../shared/services/auth/userData.service';
import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { SpinnerComponent } from '../components/spinner/spinner.component';

@Component({
  selector: 'app-building',
  standalone: true,
  imports: [
    SpinnerComponent
  ],
  templateUrl: './building.component.html',
  styleUrl: './building.component.css',
})
export class BuildingComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  buildingId: string | null = null;
  regionId: string | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.buildingId = params.get('buildingId');
      this.regionId = params.get('regionId');

      if (this.regionId) {
        this.userDataService.setRegionId(this.regionId); // set region Id from url
      }
      if (this.buildingId) { // SSR
        this.userDataService.setBuildingId(this.buildingId); // set building Id from url
        this.router.navigate(['/']);
      }
      
      if (isPlatformBrowser(this.platformId)) { // CSR
        if (this.buildingId) {
          localStorage.setItem("assess_building_id", this.buildingId); // set building Id in local storage
        }
  
        if (localStorage.getItem("assess_building_id")) { // get building Id from local storage
          this.buildingId = localStorage.getItem("assess_building_id");
          this.userDataService.setBuildingId(this.buildingId + ""); // set building Id from local storage
        }

        if (this.regionId) {
          localStorage.setItem("assess_region_id", this.regionId); // set region Id in local storage
        }

        if (localStorage.getItem("assess_region_id")) { // get region Id from local storage
          this.regionId = localStorage.getItem("assess_region_id");
          this.userDataService.setRegionId(this.regionId + ""); // set region Id from local storage
        }
      }
    });
  }
}
